import { Component } from '@angular/core';
import { BasePluginMenuComponent } from './base.menu';

@Component({
    selector: 'installation-customer-attendees-menu',
    templateUrl: './attendees.menu.html',
    standalone: false
})
export class InstallationCustomerAttendeesMenuComponent extends BasePluginMenuComponent {}
